export default {
    PRE_FIX        : 'wpo_'
}



// WEBPACK FOOTER //
// ./src/extension/payment-offline/constant/PaymentOfflineConstant.js